import { Modal, ModalProp } from "../../../components/modal/Modal";
import { Spiner } from "../../../components/spinner/Spiner";
import Button from "../../../components/button/Button";

export type ImageModalProps = {
  imagePath: string;
};

export const ImageModal = ({
  open,
  toggle,
  closeOnClickOutside,
  imagePath
}: ModalProp & ImageModalProps) => {
  return (
    <>
      <Modal
        open={open}
        toggle={toggle}
        closeOnClickOutside={closeOnClickOutside}
      >
        <div className="flex flex-col space-y-8 h-[calc(100vh_-_8rem)] p-4 mb-8 items-center rounded rounded-md relative bg-white">
          {
            imagePath === ''
              ? (<Spiner/>)
              : (<img className={"max-h-full"} src={imagePath} alt={'イメージ'}/>)
          }
            <Button
              color="violet"
              children={"閉じる"}
              onClick={toggle}
              className="w-fit"
            />
        </div>
      </Modal>
    </>
  );
};
